module.exports = __webpack_public_path__ + "img/MCD.a351cf81.png";